import { InvalidUrlError } from '@execonline-inc/url';
import { assertNever } from '@kofno/piper';
import { Maybe } from 'maybeasy';
import { AppyError } from '../../Appy';
import { MissingLinkError } from '../../Links';

export type AssistantRole = 'coach' | 'default';

export type MessageRole = 'user' | 'assistant';

export type MessagesError = AppyError | MissingLinkError | InvalidUrlError;

export interface StreamBase {
  turnUUID: string;
  seq: Maybe<number>;
}

export interface StreamedChunk extends StreamBase {
  type: 'chunk';
  content: string;
}

export interface StreamedFullText extends StreamBase {
  type: 'full-text';
  content: string;
}

export interface EndOfStream extends StreamBase {
  type: 'end-of-stream';
}

export interface StreamError extends StreamBase {
  type: 'stream-error';
  message: string;
}

export type StreamedChatMessage = StreamedChunk | StreamedFullText | EndOfStream | StreamError;

export function colorForRole(role: MessageRole) {
  switch (role) {
    case 'user':
      return 'bg-white border border-solid rounded-tl-md rounded-tr-md rounded-bl-md';
    case 'assistant':
      return 'bg-white';
    default:
      assertNever(role);
  }
}
